"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSizeme = require("react-sizeme");

var _lodash = _interopRequireDefault(require("lodash.startcase"));

var _moment = _interopRequireDefault(require("moment"));

var _Footer = _interopRequireDefault(require("../../../components/Footer"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _completed = _interopRequireDefault(require("../../../../../assets/images/completed.svg"));

var _costApproval = _interopRequireDefault(require("../../../../../assets/images/cost-approval.svg"));

var _editing = _interopRequireDefault(require("../../../../../assets/images/editing.svg"));

var _review = _interopRequireDefault(require("../../../../../assets/images/review.svg"));

var _submitted = _interopRequireDefault(require("../../../../../assets/images/submitted.svg"));

require("../styles/_summary.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var STATUS_MAP = function STATUS_MAP() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      firstSubmit = _ref.firstSubmit,
      status = _ref.status;

  return {
    EDITING: {
      Graphic: firstSubmit ? _submitted.default : _editing.default,
      title: firstSubmit ? 'Your project has been submitted for editing' : 'Your project is currently being edited',
      nextStep: firstSubmit ? 'Our Production team will go over your project brief to make sure they have everything that’s required to start editing the master version.\n' + 'Until then, sit back and relax and we will contact you if we have any questions.' : 'Our Production team is currently editing your project. You will be notified once it is done in which you can then start reviewing and commenting.'
    },
    APPROVED: {
      Graphic: _completed.default,
      title: 'Your project is already complete',
      nextStep: 'Download and share your completed videos with others.'
    },
    COST_APPROVAL: {
      Graphic: _costApproval.default,
      title: 'Your project is currently being edited',
      nextStep: 'Since your project has included additional fees to be charged, your project brief will be reviewed by your organisation admin for approval.\n' + 'Once it has been approved, it will be automatically sent to our Production team for editing.'
    },
    PENDING_REVIEW: {
      Graphic: _review.default,
      title: 'Your project is currently waiting for review',
      nextStep: 'Review and make comments on the latest version of your project by clicking ‘Review Latest Version’ down below.'
    },
    GENERAL: {
      Graphic: _review.default,
      title: "Your project is currently ".concat((0, _lodash.default)(status.toLowerCase())),
      nextStep: 'Your project brief will be reviewed by your organisation admin for approval. Once it has been approved, it will move to the next step.'
    }
  };
};

var Summary = /*#__PURE__*/function (_Component) {
  _inherits(Summary, _Component);

  var _super = _createSuper(Summary);

  function Summary() {
    var _this;

    _classCallCheck(this, Summary);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "createAnotherProject", function () {
      var history = _this.props.history;
      history.push('/builder/new');
    });

    _defineProperty(_assertThisInitialized(_this), "goToReview", function () {
      var _this$props = _this.props,
          history = _this$props.history,
          outputs = _this$props.outputs,
          videoId = _this$props.videoId;
      var masterOutputIndex = outputs.findIndex(function (output) {
        return output.isMaster;
      });
      var outputId = outputs[masterOutputIndex].outputId;
      history.rootPush("/review/".concat(videoId, "/").concat(outputId));
    });

    _defineProperty(_assertThisInitialized(_this), "goToProjects", function () {
      var history = _this.props.history;
      history.push('/');
    });

    _this.state = {};
    return _this;
  }

  _createClass(Summary, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          outputs = _this$props2.outputs,
          submittedByUser = _this$props2.submittedByUser,
          submitted = _this$props2.submitted;
      var masterOutputIndex = outputs.findIndex(function (output) {
        return output.isMaster;
      });
      var _outputs$masterOutput = outputs[masterOutputIndex],
          status = _outputs$masterOutput.status.name,
          versions = _outputs$masterOutput.versions;
      var statusMap = STATUS_MAP({
        firstSubmit: submitted,
        status: status
      });

      var _ref2 = statusMap[status] || statusMap.GENERAL,
          title = _ref2.title,
          Graphic = _ref2.Graphic,
          nextStep = _ref2.nextStep;

      var submittedAt = versions[0].submittedAt;

      var nextBlock = /*#__PURE__*/_react.default.createElement("div", {
        className: "video-summary__inner__footer-text"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading4: true
      }, 'So what\'s next?'), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        noMargin: true
      }, nextStep));

      return /*#__PURE__*/_react.default.createElement(_reactSizeme.SizeMe, {
        monitorHeight: true,
        monitorWidth: false
      }, function (_ref3) {
        var height = _ref3.size.height;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('video-summary', {
            'video-summary--small': height < 700
          })
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "video-summary__inner column"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "video-summary__inner__heading"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
          heading3: true,
          noMargin: true
        }, title), !submitted ? /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
          noMargin: "bottom",
          placeholder: true
        }, "Submitted ".concat(submittedByUser ? "by ".concat(submittedByUser.firstName, " ").concat(submittedByUser.lastName) : '', " on ").concat((0, _moment.default)(submittedAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('MMM D [at] h:mmA'))) : null, height < 700 ? nextBlock : null), /*#__PURE__*/_react.default.createElement("div", {
          className: "video-summary__inner__image-container"
        }, /*#__PURE__*/_react.default.createElement(_reactInlinesvg.default, {
          src: Graphic,
          uniquifyIDs: true,
          title: title
        })), height >= 700 ? nextBlock : null), /*#__PURE__*/_react.default.createElement(_Footer.default, {
          buttonText: submitted ? 'Create Another Project' : 'Review Latest Version',
          secondaryButtonText: "Back To Projects",
          onBackClick: _this2.goToProjects,
          onNext: submitted ? _this2.createAnotherProject : _this2.goToReview
        }));
      });
    }
  }]);

  return Summary;
}(_react.Component);

exports.default = Summary;